export default __webpack_public_path__ + "static/media/lactation-res-btn.815f60d2.svg";